import Loadable from 'react-loadable';

import { LoadingPage } from 'components/LoadingPage';

export const InvoiceSubmissionInstructionsLoadable = Loadable({
  loader: () => import('./index'),
  loading: LoadingPage,
});
